import { useStore } from '../store/useStore';
import { TerminologiaFacultad } from '../logic/types';

const TERMINOLOGIA_DEFAULT: TerminologiaFacultad = {
  materia: 'Asignatura',
  previa: 'Previatura'
};

export function useTerminologia() {
  const facultades = useStore(s => s.facultades);
  const activeFacultadId = useStore(s => s.activeFacultadId);

  const facultadActiva = facultades.find(f => f.id === activeFacultadId) || facultades.find(f => f.id === 'fcea');

  const terminologia: TerminologiaFacultad = facultadActiva?.terminologia || TERMINOLOGIA_DEFAULT;

  const materia = terminologia.materia;
  const materiaLower = materia.toLowerCase();
  
  // Plurales automáticos
  const materias = materia === 'UCO' ? 'UCOs' : `${materia}s`;
  const materiasLower = materias.toLowerCase();

  const previa = terminologia.previa || 'Previatura';
  const previas = `${previa}s`;

  return {
    materia,
    materiaLower,
    materias,
    materiasLower,
    previa,
    previas,
    facultadActiva,
    siglaFacultad: facultadActiva?.sigla || 'FCEA',
    nombreFacultad: facultadActiva?.nombre || 'Facultad'
  };
}
